"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WHAT_HAPPENS_NEXT_ANALYSIS_COPY = exports.WHAT_HAPPENS_NEXT_CONNECT_BANK_COPY = exports.WHAT_HAPPENS_NEXT_PAYMENT_COPY = exports.WHAT_HAPPENS_NEXT_SIGNUP_COPY = exports.WHAT_HAPPENS_NEXT_LABEL_COPY = exports.WHAT_HAPPENS_NEXT_TITLE_COPY = void 0;
/**
 * The "What happens next" box on every sign-up page, worded the same in both apps.
 *
 * Anthony's "How Fomo-Fi Works" (Oct 23, 2026; close_spec doc 3, "Every sign-up page")
 * replaces the provisional CALL-09 lines. Part 4 #1: the screenshots show a bold
 * "What happens next:" label followed by the line in lower case, so the lines here are
 * the screenshot's form (doc 3's table starts each with a capital; same words).
 */
exports.WHAT_HAPPENS_NEXT_TITLE_COPY = "What happens next";
/** The bold label that starts the box (screenshot form, with the colon). */
exports.WHAT_HAPPENS_NEXT_LABEL_COPY = "What happens next:";
/** 1 · Create account. */
exports.WHAT_HAPPENS_NEXT_SIGNUP_COPY = "you'll start your free trial, then connect your bank so Fomo-Fi can review 12 months of your money.";
/** 2 · Start free trial (the payment step). */
exports.WHAT_HAPPENS_NEXT_PAYMENT_COPY = "you'll connect the checking account your paychecks land in. If we can't find your bank, you won't be charged.";
/** 3 · Connect bank. */
exports.WHAT_HAPPENS_NEXT_CONNECT_BANK_COPY = "once your bank is connected, Fomo-Fi moves straight to the 12-month analysis.";
/** 4 · Analysis. */
exports.WHAT_HAPPENS_NEXT_ANALYSIS_COPY = "when the analysis completes, Fomo-Fi presents your results in Plan, where you confirm your income and build your buckets.";
//# sourceMappingURL=whatHappensNextCopy.js.map